export type CsSenderType = "CUSTOMER" | "STAFF";

export type CsChatChannel = "PLATFORM" | "SPACE";

export interface CsMessage {
  id: string;
  senderType: CsSenderType;
  senderName?: string;
  senderAvatarUrl?: string;
  senderStaffName?: string;
  content: string;
  messageType: "TEXT" | "IMAGE" | "BROADCAST";
  sentAt: string;
  recalled?: boolean;
}

export interface CsConversationBootstrap {
  conversationId: string;
}

export interface CsListMessagesResult {
  list: CsMessage[];
  hasOlder: boolean;
  /** 更早消息已超出可见窗口 */
  historyRecycled?: boolean;
}

export const CS_MAX_VISIBLE_MESSAGES = 200;
export const CS_HISTORY_RECYCLED_HINT = "历史消息已被回收，如有查询需要请联系客服";

export interface CsPollNewMessagesResult {
  list: CsMessage[];
  recalledMessageIds?: string[];
  maxRecallEventId?: string;
}

/** C 端统一展示 */
export const CS_DISPLAY_NAME = "平台客服";
export const CS_SPACE_DISPLAY_NAME = "空间客服";
export const CS_AVATAR_URL = `${process.env.PUBLIC_URL || ""}/icons/cs.png`;
/** 空会话时前端展示的欢迎语（不落库） */
export const CS_WELCOME_MESSAGE_ID = "__cs_welcome__";
export const CS_WELCOME_TEXT = "您好，有什么可以帮助您？";
